import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';

interface DialogData {
	url: string;
}

@Component({
	selector: 'qr-modal',
	templateUrl: './qr-modal.component.html',
	styleUrls: ['./qr-modal.component.scss'],
})
export class QrModalComponent implements OnInit {
	elementType = NgxQrcodeElementTypes.URL;
	correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;

	constructor(public dialogRef: MatDialogRef<QrModalComponent>, private _snackBar: MatSnackBar, @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

	onClick(): void {
		// add snackbar call here that says "Link Copied"
		this._snackBar.open('Link was copied!', undefined, {
			duration: 500,
		});
		this.dialogRef.close();
	}

	ngOnInit() {}
}
